import "babel-polyfill"
// import "../static/testBrowser.js"  //检查浏览器版本
import Vue from 'vue'
import "./assets/font-icon/iconfont.css"//自定义字体图标
import "./assets/font-icon/newfont/iconfont.css"//新自定义图标
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
import './theme/index.css'

import '@/styles/index.scss' // global css
import Vuelidate from 'vuelidate'
import App from './App'
import router from './router'
import store from './store'
import VueBus from 'vue-bus'
import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog'// error log
import './permission' // permission control
import './directive/role/index' // v-role

// import './mock' // simulation data
Vue.use(Vuelidate)
import * as filters from './filters' // global filters
import dialogDom from '@/components/Dialog'
Vue.use(dialogDom)
import searchDialog from '@/components/searchDialog'
Vue.use(searchDialog)
const config = require('@/_app/' + process.env.PROJECT + '/src/config/index.js').default
console.log(require('@/_app/' + process.env.PROJECT + '/src/config/index.js'))
const index = require('@/_app/' + process.env.PROJECT + '/src/index.js').default
require('@/_app/' + process.env.PROJECT + '/src/style/index.scss')
import report from '../src/views/report/index.vue'
import table from '../src/views/report/components/reportTable.vue'
import form from '../src/views/baseForm/index.vue'
Vue.component('base-form', form)
Vue.component('report', report)
Vue.component('report-table', table)
import helpService from '@/utils/manager'
window.utils = helpService.utils
// 父子通信
Vue.prototype.$eventBus = new Vue()

document.title = config.title

Vue.use(VueBus)
Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js